import ReactModal from "react-modal";
import { BoxModal } from "../../../components/boxModal";
import { useState } from "react";
import './styles.css'
import { useAccount } from "../../../hooks/useAccount";

export function CloseAccountModal({ isOpen, setCloseAccountModal }) {
  const [selectedReason, setSelectedReason] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { deleteAccount } = useAccount();

  const reasons = [
    { value: "", label: "Selecione o motivo" },
    { value: "0", label: "Questões relacionadas ao negócio/empresa" },
    { value: "1", label: "Mudança na situação financeira/renda" },
    { value: "2", label: "Situação de emergência" },
    { value: "3", label: "Motivos educacionais/acadêmicos" },
    { value: "4", label: "Questões de saúde" },
    { value: "5", label: "Viagem/mudança de localização" },
    { value: "6", label: "Reforma/reestruturação" },
    { value: "7", label: "Outros motivos" }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedReason || !acceptTerms) return;
    setIsSubmitting(true);
    try{
      await deleteAccount(selectedReason);
    } catch(err) {
      console.error(err);
      toast.error(err?.response?.data?.message || 'Não foi possivel encerrar a conta');
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setSelectedReason("");
    setAcceptTerms(false);
    setIsSubmitting(false);
  };

  const handleClose = () => {
    resetForm();
    setCloseAccountModal(false);
  };

  const isFormValid = selectedReason && acceptTerms;

  return (
    <ReactModal 
      isOpen={isOpen} 
      className="change-modal" 
      overlayClassName="overlay-change-password-modal"
      onRequestClose={handleClose}
    >
      <BoxModal title={'Encerrar Conta'} maxWidth={680} close={handleClose}>
        <div className="close-account-content">
          <div className="close-account-header">
            <div className="warning-icon">
              ⚠️
            </div>
            <h3>Tem certeza que deseja encerrar sua conta?</h3>
            <p className="warning-text">
              Esta ação não pode ser desfeita. Todos os seus dados serão permanentemente removidos.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="close-account-form">
            <div className="form-group">
              <label htmlFor="reason" className="form-label">
                Motivo do encerramento *
              </label>
              <select
                id="reason"
                value={selectedReason}
                onChange={(e) => setSelectedReason(e.target.value)}
                className="form-select"
                required
              >
                {reasons.map((reason) => (
                  <option key={reason.value} value={reason.value}>
                    {reason.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="important-info">
              <div className="info-card">
                <div className="info-icon">ℹ️</div>
                <div className="info-content">
                  <h4>O que acontecerá:</h4>
                  <ul>
                    <li>Sua conta será desativada em até 24 horas</li>
                    <li>Todos os seus dados serão removidos permanentemente</li>
                    <li>Você não poderá mais acessar os serviços</li>
                    <li>Esta ação não pode ser revertida</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={acceptTerms}
                  onChange={(e) => setAcceptTerms(e.target.checked)}
                  className="checkbox-input"
                  required
                />
                <span className="checkbox-custom"></span>
                <span className="checkbox-text">
                  Li e aceito os <a href="/termos" target="_blank">termos e condições</a> para encerramento de conta. 
                  Entendo que esta ação é irreversível e que todos os meus dados 
                  serão permanentemente removidos.
                </span>
              </label>
            </div>

            <div className="close-account-form-actions">
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-secondary"
                disabled={isSubmitting}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!isFormValid || isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="loading-spinner"></span>
                    Processando...
                  </>
                ) : (
                  'Encerrar Conta'
                )}
              </button>
            </div>
          </form>
        </div>
      </BoxModal>
    </ReactModal>
  )
}